export const fileToBase64Async = (file: File): Promise<string | null> => {
  const reader = new FileReader();
  reader.readAsDataURL(file);

  return new Promise((resolve) => {
    reader.onload = () => {
      // remove data url header
      const base64 = reader.result?.toString().split(',')[1];
      resolve(base64 as string);
    };

    reader.onerror = (error) => {
      console.error('Error: ', error);
      resolve(null);
    };
  });
};
